// 页内标签：几个相关页面合在左侧菜单的一项下（任务类型 / 健康面板；系统 / 账号 / AGENTS.md），各自保留原来的网址
import { NavLink } from "react-router-dom";

export const TYPE_TABS = [
  { to: "/admin/types", label: "类型列表" },
  { to: "/admin", label: "健康面板" },
];

export const SYSTEM_TABS = [
  { to: "/admin/system", label: "系统" },
  { to: "/admin/users", label: "账号" },
  { to: "/admin/agents-md", label: "AGENTS.md" },
];

export function SubTabs({ tabs }: { tabs: { to: string; label: string }[] }) {
  return (
    <div className="seg sub-tabs" data-testid="sub-tabs">
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} end className={({ isActive }) => (isActive ? "active" : undefined)}>
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
